import { render } from "./ModalNewsEdit.vue?vue&type=template&id=75c5a009&scoped=true"
import script from "./ModalNewsEdit.vue?vue&type=script&lang=js"
export * from "./ModalNewsEdit.vue?vue&type=script&lang=js"

import "./ModalNewsEdit.vue?vue&type=style&index=0&id=75c5a009&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c5a009"]])

export default __exports__